var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.143,
    height: 23.327,
    viewBox: "0 0 23.143 23.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M53.248,36.455a11.575,11.575,0,0,0-18.543,13.39l-1.228,5.962a.441.441,0,0,0,.07.346.448.448,0,0,0,.475.185l5.844-1.385a11.573,11.573,0,0,0,13.382-18.5ZM51.426,51a9.066,9.066,0,0,1-10.44,1.7l-.814-.4-3.583.848L36.6,53.1l.742-3.606-.4-.787A9.061,9.061,0,0,1,51.426,38.184a.483.483,0,0,0,.047.047A9.061,9.061,0,0,1,51.426,51Z",
    transform: "translate(-33.447 -33.024)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M72.433,70.6a3.763,3.763,0,0,1-2,1.748c-1.527.369-3.871.013-6.787-2.707l-.036-.032c-2.564-2.378-3.23-4.357-3.069-5.926a3.751,3.751,0,0,1,1.457-2.223.834.834,0,0,1,1.3.3l.944,2.121a.829.829,0,0,1-.1.848l-.477.619a.821.821,0,0,0-.074.916,8.918,8.918,0,0,0,1.618,1.8,9.446,9.446,0,0,0,2.242,1.606.81.81,0,0,0,.889-.187l.554-.558a.848.848,0,0,1,.827-.212l2.242.636a.848.848,0,0,1,.475,1.254Z",
    transform: "translate(-54.771 -55.271)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWhatsapp);
export default __webpack_public_path__ + "static/media/ico-whatsapp.793afa72c9e0da58223e5935f3699542.svg";
export { ForwardRef as ReactComponent };